angular.module('jv.Dashboard.My.Open.Jobs.Pending.Evaluations.Controller', ['jv.Common.Directives.jvTinymce'])
.controller('jv.Dashboard.My.Open.Jobs.Pending.Evaluations.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', '$rootScope', 'jvDashboardFactory','jvHireUrlService',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, $rootScope, jvDashboardFactory, jvHireUrlService){
        jvContextualLoadingService.hide($scope.widgetObject.widgetId);

        var _widgetSettings = $scope.widgetObject.userWidgetSettings.widgetSetting;

        $scope.duration = 0;
        $scope.pageSize = 5;
        $scope.totalCount = 0;
        $scope.currentPage = 0;
        $scope.todayDate = new Date();
        $scope.modal={
            sendReminder:{}
        };

        var init = function(){
            angular.forEach(_widgetSettings, function(widgetSetting, index){
                var settingObject;
                if (widgetSetting.userValues) {
                    settingObject = widgetSetting.userValues[0];
                }else {
                    if(widgetSetting.settings.defaultValues){
                    settingObject = widgetSetting.settings.defaultValues[0];
                    }
                }
                switch(widgetSetting.settings.name) {
                case "Duration":
                    $scope.duration = settingObject.value;
                    break;
                default:
                    break;
                }
            });
        };

        $scope.getMyJobPendingEvaluations = function(pageNumber) {
            jvContextualLoadingService.show($scope.widgetObject.widgetId);
            $scope.currentPage = pageNumber;
            var args = {
                page: $scope.currentPage,
                pageSize: $scope.pageSize,
                days: $scope.duration
            };

            /*
            Making sure we send refresh true for new widget creating flow
            Cannot set refresh true in the REFRESH_WIDGET emit callback since the controller gets re-initialized for a newly added widget.
            Hence storing this in the factory 
            */
            //send refresh=true to get data from DB
            if($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject)){
                args.refresh = true;
            }
            jvDashboardAjaxService.getMyOwnedJobsPendingEvaluations(args, function(response) {
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                if (response && response.evaluationInfo) {
                    $scope.evaluations = response.evaluationInfo;
                    $scope.lastUpdated = response.lastUpdated;
                    $scope.totalCount = response.count;
                } else {
                    $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                }
            });
        };

        $scope.interviewDetails = function(interview){
            if(!interview.expand){
                jvContextualLoadingService.show($scope.widgetObject.widgetId);

                var args={
                    params:{
                        applicationEId: interview.applicationEId,
                        interviewEId: interview.interviewEId
                    },
                    groupId: interview.groupId,
                    excludeCompleted: true
                };

                jvDashboardAjaxService.getEvaluationDetail(args, function(res){
                    jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                    interview.interviews = res.interview;
                });
            }

            if(!interview.expand){
                for(var index in $scope.evaluations){
                    $scope.evaluations[index].expand = false;
                }
            }

            interview.expand = !interview.expand;
        };

        $scope.submit = function(interview, evaluation){
            $window.location.href = jvHireUrlService.getApplicationDetailsUrlWithTab(evaluation.applicationEId,{},'evaluations-submit/{0}/{1}/{2}'.format(evaluation.applicationEId,evaluation.candidateStateEId,interview.EId));
        };

        $scope.remind = function(evaluation, interview){
            jvContextualLoadingService.show($scope.widgetObject.widgetId);
            var args ={
                params:{
                    applicationEId: evaluation.applicationEId,
                    candidateStateEId: evaluation.candidateStateEId                 
                },
                groupId: evaluation.groupId
            };

            if(interview){
                args.interviewEId = interview.EId;
            }
            
            jvDashboardAjaxService.getEvaluationReminderTmpl(args, function(res){
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                $scope.modal.sendReminder = {};
                $scope.modal.sendReminder.show=true;                
                $scope.modal.sendReminder.evaluation = evaluation;
                if(interview){
                    $scope.modal.sendReminder.interview = interview;
                }
                $scope.modal.sendReminder = angular.extend(res.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage, $scope.modal.sendReminder);
            });
        };
        
        $scope.sendReminder = function(modalObj){
            if(!modalObj.content || !modalObj.subject){
                return;
            }else if(modalObj.content.trim().length < 0 || modalObj.subject.trim().length < 0){
                return;
            }
            
            var interviews = modalObj.evaluation.interviews;
            var args ={
                params:{
                    applicationEId: modalObj.evaluation.applicationEId,
                    candidateStateEId: modalObj.evaluation.candidateStateEId
                },
                content: modalObj.content,
                subject: modalObj.subject,
                from: {eid : $window.jvUser},
                to: [],
                entityIdList: []
            };
            
            for(var i=0; i<modalObj.to.length; i++){
                args.to.push({eid: modalObj.to[i].EId});
            }
            
            if(modalObj.interview){
                args.entityIdList.push(modalObj.interview.EId);
            }else{
                for(var j=0; j<interviews.length; j++){
                    args.entityIdList.push(interviews[j].EId);
                }
            }
            
            $rootScope.flags.loading = true;
            jvDashboardAjaxService.sendEvaluationReminderTmpl(args, function(res){
                $rootScope.flags.loading = false;
                if(res.msgInfo === 200){
                    $scope.$emit('showMessageBar', i18n['REMINDER_SENT']);
                    $scope.modal.sendReminder.show=false;
                }else{
                    $scope.$emit('showMessageBar', i18n['ERROR_PROCESSING_REQUEST']);
                }
            });
        };

        $scope.cancelSendReminder = function(){
            $scope.modal.sendReminder.show=false;
        };

        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                //invalidate cache and fetch data from DB 
                $scope.lastUpdated = '';
                $scope.refresh = true;
                init();
                $scope.getMyJobPendingEvaluations(0);
            }
        });
        
        init();
        $scope.getMyJobPendingEvaluations(0);
}]);